import { useEffect, useState } from "react";

const DEFAULT_BREAKPOINT = 768;
type WindowLike = {
  innerWidth: number;
  addEventListener: (type: string, listener: () => void) => void;
  removeEventListener: (type: string, listener: () => void) => void;
};

const getWindowLike = (): WindowLike | undefined => {
  const maybeGlobal = globalThis as { window?: unknown };
  const maybeWindow = maybeGlobal.window;
  if (!maybeWindow) return undefined;

  const candidate = maybeWindow as Partial<WindowLike>;
  if (
    typeof candidate.innerWidth !== "number" ||
    typeof candidate.addEventListener !== "function" ||
    typeof candidate.removeEventListener !== "function"
  ) {
    return undefined;
  }

  return candidate as WindowLike;
};

export const useIsMobile = (breakpoint: number = DEFAULT_BREAKPOINT) => {
  const [isMobile, setIsMobile] = useState(() => {
    const win = getWindowLike();
    return win ? win.innerWidth <= breakpoint : false;
  });

  useEffect(() => {
    const win = getWindowLike();
    if (!win) return;

    const handleResize = () => {
      setIsMobile(win.innerWidth <= breakpoint);
    };

    handleResize();
    win.addEventListener("resize", handleResize);
    return () => win.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isMobile;
};
